import { useState } from 'react';

import { useUserRoleMapper } from '@/hook';
import { VFlex, VInput, VStack, VTextButton } from '@/package';
import type { User } from '@/type';

import { UserProfileChangeRoleModal } from './UserProfileChangeRoleModal';

export const ChangeRole = ({
  selectedUser,
  isUserEditable,
  updateMyUserInfo,
}: {
  selectedUser: User;
  isUserEditable: boolean;
  updateMyUserInfo?: (user: User) => void;
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const { mapUserRole } = useUserRoleMapper();

  const onUserRoleChangeButtonClick = () => {
    setModalVisible(true);
  };

  return (
    <VStack gap={0.25} className="w-full">
      <VInput
        fluid
        label="Role"
        value={mapUserRole(selectedUser?.role)}
        readOnly={!isUserEditable}
      />
      {isUserEditable && (
        <VFlex className="w-full" justify="end">
          <VTextButton size="md" onClick={() => onUserRoleChangeButtonClick()}>
            Change role
          </VTextButton>
        </VFlex>
      )}

      <UserProfileChangeRoleModal
        selectedUser={selectedUser}
        visible={modalVisible}
        onUpdateVisible={setModalVisible}
        updateMyUserInfo={updateMyUserInfo}
      />
    </VStack>
  );
};
